export const pluralize = (count: number, noun: string, pluralNoun?: string): string => {
  return count === 1 ? noun : (pluralNoun ?? `${noun}s`)
}

export const boolToYN = (val: boolean) => val ? 'Y' : 'N'